import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import PageSection from 'components/PageSection';
import Button from 'components/Button';
function CoachAiWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(PageSection, {
    maxWidth: 440
  }, /*#__PURE__*/React.createElement(Button, {
    as: NavLink,
    to: "coach-ai",
    size: "large",
    icon: "sparkles",
    align: "center",
    mt: "m",
    fullWidth: true
  }, t('coach_ai_ask', {
    coachAiName: config.coachAiName
  })));
}
export default CoachAiWidget;